<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('loginOut.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('loginOut.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-border ts-p-3 ts-rounded-md ts-flex ts-space-x-3">
            <a-select
              mode="multiple"
              show-search
              v-model="userId"
              placeholder="input search user name"
              style="width: 400px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearch"
            >
              <a-select-option
                v-for="(d, index) in data"
                :key="index"
                :value="d.user_id"
              >
                {{ d.name }}
              </a-select-option>
            </a-select>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
            />
            <ts-button color="primary" @click.prevent="fetch">{{ $t('loginOut.search') }}</ts-button>
          </div>
          <h4 class="ts-mt-3">{{ $t('loginOut.logout') }}</h4>
          <div class="ts-border ts-rounded-md ts-p-3">
						<div class="loginInfo">
              <ts-table 
								:columns="columnsLogOut" 
								:records="logoutResources"
							>
                <template v-slot="{ record }">
                  <td class="ts-whitespace-no-wrap">{{ record.name }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.user_name }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.logout_date }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.ip }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.role_name }}</td>
                </template>
              </ts-table>
            </div>
						<div class="d-flex justify-content-end p-15">
								<ts-pagination v-model="logoutPagination" @navigate="fetchLogOutPerpage">
								</ts-pagination>
						</div>
					</div>
          <h4 class="ts-mt-3">{{ $t('loginOut.logIn') }}</h4>
          <div class="ts-border ts-rounded-md ts-p-3">
            <div class="loginInfo">
              <ts-table 
								:columns="columnsLogin" 
								:records="resources"
							>
                <template v-slot="{ record }">
                  <td class="ts-whitespace-no-wrap">{{ record.name }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.user_name }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.login_date }}</td>
                  <td class="ts-whitespace-no-wrap">{{ record.role_name }}</td>
                </template>
              </ts-table>
            </div>
						<div class="d-flex justify-content-end p-15">
								<ts-pagination v-model="pagination" @navigate="fetchLoginPerpage">
								</ts-pagination>
						</div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'loginOut',
  data() {
    return {
      loading: false,
      model: {
        value: undefined
      },
      data: []
    }
  },
  computed: {
    ...mapState('security/loginOut', ['resources', 'pagination', 'logoutResources', 'logoutPagination']),
		dateRange: {
      get() {
        return this.$store.state.security.loginOut.dateRange
      },
      set(newValue) {
        this.$store.commit('security/loginOut/SET_DATE_RANGE', newValue)
      },
    },
		userId: {
      get() {
        return this.$store.state.security.loginOut.userId
      },
      set(newValue) {
        this.$store.commit('security/loginOut/SET_USER_ID', newValue)
      },
    },
    columnsLogin() {
      return [
        { name: this.$t('loginOut.name') },
        { name: this.$t('loginOut.userName') },
        { name: this.$t('loginOut.loginDate') },
        { name: this.$t('loginOut.roleName') }
      ]
    },
    columnsLogOut() {
      return [
        { name: this.$t('loginOut.name') },
        { name: this.$t('loginOut.userName') },
        { name: this.$t('loginOut.logoutDate') },
        { name: this.$t('loginOut.iP') },
        { name: this.$t('loginOut.roleName') }
      ]
    }
  },
  methods: {
    ...mapActions('security/loginOut', ['getUser', 'fetchLogin', 'logoutInfo']),
    async fetch() {
      this.loading = true
      await this.fetchLogin()
      await this.logoutInfo()
      this.loading = false
    },
		async fetchLoginPerpage(attributes = {}){
      this.loading = true
      await this.fetchLogin(attributes)
      this.loading = false
		},
		async fetchLogOutPerpage(attributes = {}){
      this.loading = true
      await this.logoutInfo(attributes)
      this.loading = false
		},
    handleSearch: debounce(function(value) {
      this.loading = true
      this.getUser({
        search: value
      })
        .then(re => {
          this.data = re.data
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => (this.loading = false))
    }, 800),
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetch()
    })
  }
}
</script>

<style scoped>
	.loginInfo {
		/* height: 400px; */
		max-height: 450px;
		overflow: scroll;
	}
</style>